import React, { useState } from 'react'
import { TextareaNesting } from '../../common/Inputs/Input'
import BoxInfo from '../../common/BoxInfo'
import ButtonYesNo from '../../common/ButtonYesNo'
import { useTranslate } from '../../../lib'
import PromptTemplateModal from '../../PromptTemplateModal'

export default function ContactDriverForm({
  contactDriverForm,
  showContactDriverForm,
  contact_driver_context_ref,
  contact_driver_rules_ref,
  contact_driver_forbidden_actions_ref,
  contact_driver_default_fallback_ref,
  contact_driver_example_ref,
  contact_driver_other_ref,
  use_new_prompt,
  onMigratePrompt,
}) {
  const { t } = useTranslate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSelectTemplate = (templateContent) => {
    
    const content = typeof templateContent === 'string' ? templateContent : templateContent.content;
    
    if (contact_driver_context_ref && contact_driver_context_ref.current) {
        const currentValue = contact_driver_context_ref.current.value || '';
        const newValue = (currentValue ? currentValue + "\n" : "") + content;
        
        contact_driver_context_ref.current.value = newValue;
        
        const event = new Event('input', { bubbles: true });
        contact_driver_context_ref.current.dispatchEvent(event);
    }
    
    setIsModalOpen(false);
  };

  return (
    <>
      <div className='d-flex flex-row align-items-center justify-content-between w-100 shadow_box'
        style={{ backgroundColor: '#0088ff09', padding: 10, borderRadius: '10px 10px 0 0' }}>
        <div className='d-flex flex-row align-items-center w-100'>
          <div className='w-100' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2 onClick={() => showContactDriverForm(!contactDriverForm)} className="m-0" style={{ color: '#0B5FA3', fontSize: 15, cursor: "pointer" }}>
              {t('menu.genai.contactDriver')}
            </h2>

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>

              <button 
                  type="button"
                  className='btn-add' 
                  onClick={() => setIsModalOpen(true)}
                  style={{ 
                      border: 'none', 
                      background: '#c4e3fc', 
                      color: '#0B5FA3', 
                      padding: '8px 15px', 
                      borderRadius: '5px',
                      fontSize: 12,
                      display: contactDriverForm ? 'flex' : 'none',
                      alignItems: 'center',
                      marginRight: 10,
                      fontWeight: 800,
                      textTransform: 'uppercase',
                  }}
              >
                  <img src='/icons/prompt-template-icon.png' style={{ width: 25, marginRight: 7 }} alt='' />
                  <div>{t('common.templates')}</div>
              </button>

              <button
                id='arrow-down-btn'
                style={{ display: !contactDriverForm ? 'block' : 'none' }}
                className='ml-3'
                type='button'
                onClick={() => showContactDriverForm(true)}
              >
                <img src='/icons/arrow_down.png' style={{ width: 15 }} alt='' />
              </button>

              <button
                id='arrow-down-btn'
                style={{ display: contactDriverForm ? 'block' : 'none' }}
                className='ml-3'
                type='button'
                onClick={() => showContactDriverForm(false)}
              >
                <img src='/icons/arrow_up.png' style={{ width: 15 }} alt='' />
              </button>
            </div>

            
          </div>


        </div>
      </div>

      {/* CONTENIDO DESPLEGABLE */}
      <div style={{ display: contactDriverForm ? 'flex' : 'none', backgroundColor: '#0088ff09', padding: '10px 10px 10px 10px' }}
        className="flex-row flex-wrap pt-5">

        {use_new_prompt === 0 && (
          <div
            className="d-flex flex-row flex-wrap w-100 mb-3 p-1"
            style={{
              backgroundColor: '#fff7e6',
              border: '1px solid #ffd591',
              borderRadius: 8
            }}
          >
            <div
              style={{
                fontSize: 14,
                color: '#2E2E2E',
                fontWeight: 400,
                marginTop: 4
              }}
            >
              {t('menu.genai.migrateNewPrompt')}:
            </div>

            <div className="d-flex flex-row align-items-center ml-1">
              <button type='button'
                  onClick={(value) => {
                    const confirmed = window.confirm(t('menu.genai.migrateNewPromptIrreversibleConfirm'));

                    if(confirmed){
                      onMigratePrompt();
                    }
                    
                  }}
                  className='buttonE'>
                {t('common.update')}
              </button>

              <div
                style={{
                  marginLeft: 12,
                  fontSize: 12,
                  color: '#8c8c8c',
                  whiteSpace: 'nowrap',
                  fontWeight: 400,
                }}
              >
                {t('menu.genai.migrateNewPromptIrreversible')}
              </div>
            </div>
          </div>
        )}


        {/* CONTEXT */}
        <div className='d-flex flex-column w-100 mt-1'>
          <label htmlFor="contact_driver_context" style={{ fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>
            {t('menu.genai.context')}:
          </label>
          <TextareaNesting
            row={11}
            ref={contact_driver_context_ref}
            id="contact_driver_context"
            containerClass="flex-1 mr-2 mt-1 w-100"
          />
        </div>

        {use_new_prompt === 0 && (
          <div className='w-100'>
            <div className='d-flex flex-column w-100 mt-3' style={{ flexGrow: '1' }}>
              <div className='d-flex flex-row align-items-center justify-content-between'>
                <label htmlFor="contact_driver_rules" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.rules')}:</label>
              </div>
              <div className='flex items-center w-100'>
                <TextareaNesting
                  row={4}
                  ref={contact_driver_rules_ref} id="contact_driver_rules"
                  title="" containerClass="flex-1 mr-2 mt-0 w-100"
                />
              </div>
            </div>

            <div className='d-flex flex-column w-100 mt-3' style={{ flexGrow: '1' }}>
              <div className='d-flex flex-row align-items-center justify-content-between'>
                <label htmlFor="contact_driver_forbidden_actions" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.forbiddenActions')}:</label>
              </div>
              <div className='flex items-center w-100'>
                <TextareaNesting
                  row={4}
                  ref={contact_driver_forbidden_actions_ref} id="contact_driver_forbidden_actions"
                  title="" containerClass="flex-1 mr-2 mt-0 w-100"
                />
              </div>
            </div>

            <div className='d-flex flex-column w-100 mt-3' style={{ flexGrow: '1' }}>
              <div className='d-flex flex-row align-items-center justify-content-between'>
                <label htmlFor="contact_driver_default_fallback" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.defaultFallback')}:</label>
              </div>
              <div className='flex items-center w-100'>
                <TextareaNesting
                  row={4}
                  ref={contact_driver_default_fallback_ref} id="contact_driver_default_fallback"
                  title="" containerClass="flex-1 mr-2 mt-0 w-100"
                />
              </div>
            </div>
          </div>
        )}

        <div className='w-100'>
          <div className='d-flex flex-column w-100 mt-2'>
            {/* EXAMPLE */}
            <label htmlFor="contact_driver_example" style={{ fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>
              {t('menu.genai.example')}:
            </label>
            <TextareaNesting
              row={4}
              ref={contact_driver_example_ref}
              id="contact_driver_example"
              containerClass="flex-1 mr-2 mt-1"
            />
          </div>
        </div>

        {use_new_prompt === 0 && (
          <div className='w-100'>
            {/* OTHER - OPCIONAL */}
            <div className='d-flex flex-column w-100 mt-2'>
              <label htmlFor="contact_driver_other" style={{ fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>
                Other:
              </label>
              <TextareaNesting
                row={4}
                ref={contact_driver_other_ref}
                id="contact_driver_other"
                containerClass="flex-1 mr-2 mt-1"
              />
            </div>
          </div>

        )}

      </div>

      <PromptTemplateModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSelect={handleSelectTemplate}
        hideCreate={false}
      />

    </>
  );
}
